import { z } from "zod";
import { sessionClipSchema, sessionStatusSchema } from "./sessions.js";
export const twinSessionOwnerSchema = z.object({
    id: z.string().trim().min(1),
    displayName: z.string().trim().min(1).max(200).optional(),
    avatarUrl: z.string().url().optional(),
}).strict();
export const twinSessionSummarySchema = z.object({
    id: z.string().trim().min(1),
    title: z.string().trim().min(1),
    owner: twinSessionOwnerSchema,
    status: sessionStatusSchema,
    channelId: z.string().trim().min(1).optional(),
    createdAt: z.number(),
    updatedAt: z.number(),
    startedAt: z.number().optional(),
    finishedAt: z.number().optional(),
}).strict();
const referenceIdSchema = z.string().trim().min(1).max(200);
/**
 * What a question or a follow-up carries of what is in front of the person: Twin records, entities and files by ID,
 * which the control plane reads as the person may, and excerpts of text from their own screen, each up to 4,000
 * characters with where it came from, quoted to the agent as the person's own, never as instructions.
 */
export const twinSessionReferencesSchema = z.object({
    recordIds: z.array(referenceIdSchema).max(50).optional(),
    entityIds: z.array(referenceIdSchema).max(10).optional(),
    fileIds: z.array(referenceIdSchema).max(50).optional(),
    clips: z.array(sessionClipSchema).max(20).optional(),
}).strict();
